import React from 'react';
import styles from './badge.module.scss';
export default function Badge({ children, color, ...rest }) {
  return (
    <div className={`${styles.badge} ${styles[color]}`} {...rest}>
      {children}
    </div>
  );
}
